import { useEffect } from 'react'
import useAcceptVenueInvitations from '../../../hooks/useAcceptVenueInvitations';

export  function useCheckAndAcceptInvitations(merchant:any , isMerchantLoading:boolean) {

  const { 
    checkAndAcceptInvitations, 
    isLoading: isCheckingInvitations,
    hasInvitations
} = useAcceptVenueInvitations(); 


useEffect(() => {
  if(merchant && merchant?.id && !isMerchantLoading) {
      checkAndAcceptInvitations(merchant.id);
  }
  //eslint-disable-next-line
}, [merchant , isMerchantLoading])


  return {
    isCheckingInvitations,
    hasInvitations
  }
}
